import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BASE_URL } from '../config/api';

const EditBankReceived = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        staff_id: '',
        c_id: '',
        amount: '',
        description: '',
    });
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    useEffect(() => {
        fetch(`${BASE_URL}bankreceived/${id}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 1) {
                    setFormData(data.data);
                } else {
                    setErrorMessage('Failed to fetch data');
                }
            })
            .catch((error) => {
                setErrorMessage('An error occurred while fetching data.');
                console.error('Error:', error);
            });
    }, [id]);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        fetch(`${BASE_URL}bankreceived/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 1) {
                    setSuccessMessage(data.message);
                    setErrorMessage('');
                    navigate('/BankReceivedList');
                } else {
                    setErrorMessage(data.message || 'Error updating entry.');
                    setSuccessMessage('');
                }
            })
            .catch((error) => {
                setErrorMessage('An error occurred. Please try again.');
                console.error('Error:', error);
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <h3>Edit Bank Received</h3>
            </header>

            <section className="section">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    {errorMessage && (
                                        <div className="alert alert-danger">{errorMessage}</div>
                                    )}
                                    {successMessage && (
                                        <div className="alert alert-success">{successMessage}</div>
                                    )}

                                    <div className="mb-3">
                                        <label htmlFor="staff_id" className="form-label">
                                            Staff ID
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="staff_id"
                                            name="staff_id"
                                            value={formData.staff_id}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="c_id" className="form-label">
                                            Customer ID
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="c_id"
                                            name="c_id"
                                            value={formData.c_id}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="amount" className="form-label">
                                            Amount
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="amount"
                                            name="amount"
                                            value={formData.amount}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">
                                            Description
                                        </label>
                                        <textarea
                                            className="form-control"
                                            id="description"
                                            name="description"
                                            value={formData.description}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">
                                            Update
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditBankReceived;
